import Luiv3Constants from '@app/lui3/constants';
import {IconName, IconStyle} from '@fortawesome/fontawesome-common-types';
import {
  FlipProp,
  RotateProp,
  SizeProp,
} from '@fortawesome/fontawesome-svg-core';
import {ComponentProps} from 'react';
import styled from 'styled-components';

export const FA_BRAND_ICONS = ['chrome'];

export type CustomIconName =
  | 'custom-arrow-rotate-left-user-regular'
  | 'custom-arrow-rotate-right-user-regular'
  | 'custom-building-plus-solid'
  | 'custom-bullhorn-solid'
  | 'custom-bullhorn-sparkles-regular'
  | 'custom-calendar-regular'
  | 'custom-calendar-solid'
  | 'custom-checklist-regular'
  | 'custom-checklist-solid'
  | 'custom-clock-lock-solid'
  | 'custom-envelope-arrow-down-regular'
  | 'custom-envelope-sparkles-regular'
  | 'custom-envelope-sparkles-solid'
  | 'custom-font-color-solid'
  | 'custom-google-chrome-regular'
  | 'custom-list-clock-solid'
  | 'custom-message-sms-sparkles-regular'
  | 'custom-message-sparkles-solid'
  | 'custom-message-sparkles-regular'
  | 'custom-pen-sparkles-regular'
  | 'custom-pen-sparkles-solid'
  | 'custom-phone-arrow-down-regular'
  | 'custom-phone-lines-regular'
  | 'custom-phone-sparkles-regular'
  | 'custom-phone-sparkles-solid'
  | 'custom-presentation-screen-user-solid'
  | 'custom-ranking-sparkles-regular'
  | 'custom-ranking-sparkles-solid'
  | 'custom-search-sparkles-outline'
  | 'custom-search-sparkles-solid'
  | 'custom-sidebar-regular'
  | 'custom-thumbsup-sparkles-solid'
  | 'custom-user-group-regular'
  | 'custom-user-group-solid'
  | 'custom-user-sparkles-regular'
  | 'custom-user-sparkles-solid'
  | 'custom-bullhorn-sparkles-solid'
  | 'custom-database-sparkles-solid'
  | 'custom-video-sparkles-solid';

type CustomSizeProp = 'custom-md';

interface Props extends ComponentProps<typeof StyledIcon> {
  faStyle?: 'kit' | IconStyle;
  icon: IconName | CustomIconName;
  size?: SizeProp | CustomSizeProp;
  className?: string;
  flip?: FlipProp;
  rotate?: RotateProp;
  color?: keyof typeof Luiv3Constants.baseColor;
  spin?: boolean;
  width?: string;
}

const StyledIcon = styled.i<{
  color?: keyof typeof Luiv3Constants.baseColor;
  $width?: string;
}>`
  display: inline-block;
  ${({color}) => color && `color: ${Luiv3Constants.baseColor[color]};`}
  ${({$width}) => $width && `width: ${$width};`}

  /* Custom size: 1.143em (16/14 ratio) */
  &.fa-custom-md {
    font-size: 1.143em;
  }
`;

const FaIcon = ({
  faStyle = 'regular',
  icon,
  size = 'custom-md',
  className,
  flip,
  rotate,
  color,
  width,
  spin = false,
  ...props
}: Props) => {
  // Custom icons must use style "kit"
  if (icon.startsWith('custom-') && faStyle !== 'kit') {
    faStyle = 'kit';
  }
  const iconClasses = [
    `fa-${faStyle}`,
    `fa-${icon}`,
    `fa-${size}`,
    flip && `fa-flip-${flip}`,
    rotate && `fa-rotate-${rotate}`,
    spin && `fa-spin`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <StyledIcon
      className={iconClasses}
      $width={width}
      color={color}
      {...props}
    />
  );
};

export default FaIcon;
